import {
    METHOD_DELETE,
    METHOD_GET,
    METHOD_POST,
    METHOD_PUT,
    SERVER_URL,
} from '../constants/api';
import {
    headersAuth,
    headersAuthReceiveJson, headersAuthSendReceiveJson
} from '../../store/headers';
import { apiHandleResponse, apiClientCreateHandleResponse } from '../../util/api';
import { http } from "./common";

const getClients = () => {
    return fetch(`${SERVER_URL}/api/v2/client`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const getClientsTiny = () => {
    return fetch(`${SERVER_URL}/api/v2/client/tiny`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const createClient = (client) => {
    return fetch(`${SERVER_URL}/api/v2/client`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};

const createClientV3 = (client) => {
    return fetch(`${SERVER_URL}/api/v3/client`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};

const addProducts = (client) => {
    return fetch(`${SERVER_URL}/api/v3/product`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};

const addBuckets = (client) => {
    return fetch(`${SERVER_URL}/api/v3/bucket`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};


const updateClient = (client) => {
    return fetch(`${SERVER_URL}/api/v2/client`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};

const updateClientNew = (client) => {
    return fetch(`${SERVER_URL}/api/v3/client`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};

const getClient = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/id=${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};


const getClientAddress = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/address/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};


const getParsers = () => {
    return fetch(`${SERVER_URL}/api/v1/client/parsers`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const bucketAvailability = (bucketName) => {
    return fetch(`${SERVER_URL}/api/v1/client/buckets/sliced-${bucketName}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const ftpuserAvailability = (username) => {
    return fetch(`${SERVER_URL}/api/v1/client/check/ftpuser/admin-${username}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};


const deactivateClient = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/${clientId}`, {
        method: METHOD_DELETE,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};


const activateClient = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/activate/${clientId}`, {
        method: METHOD_POST,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const getConfiguration = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getPlanIdMappingAccess = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/planidmapping/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getRcmTeamAccess = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/rcmteam/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getEapgAccess = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/eapg/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getAIAccess = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/contractdocumentchatbot/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getClaimAnalysisChatbotAccess = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/claimanalysischatbot/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getAccountConfiguration = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/account/configuration/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getFHIRConfiguration = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/fhir/configuration/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const createConfiguration = (clientConfigs) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(clientConfigs)
    }).then(apiHandleResponse);
};

 const checkIfFHIRConfigExists = async () => {
        const json = await http.get( `/api/v1/fhir/isConfigured`);
        return json
    }


const addClaims = (claims) => {
    return fetch(`${SERVER_URL}/api/v2/client/account/configuration/validate`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(claims)
    }).then(apiHandleResponse);
};

const createAccountConfiguration = (clientAccountConfigs) => {
    return fetch(`${SERVER_URL}/api/v2/client/account/configuration`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(clientAccountConfigs)
    }).then(apiHandleResponse);
};

const createFHIRConfiguration = (clientFHIRConfigs) => {
    return fetch(`${SERVER_URL}/api/v2/client/fhir/configuration`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(clientFHIRConfigs)
    }).then(apiHandleResponse);
};

const testFHIRConnection = (clientFHIRConfigs) => {
    return fetch(`${SERVER_URL}/api/v2/client/fhir/test`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(clientFHIRConfigs)
    }).then(apiHandleResponse);
};


const editConfiguration = (clientConfigs) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(clientConfigs)
    }).then(apiHandleResponse);
};

const editAccountConfiguration = (clientConfigs) => {
    return fetch(`${SERVER_URL}/api/v2/client/account/configuration`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(clientConfigs)
    }).then(apiHandleResponse);
};

const editFHIRConfiguration = (clientConfigs) => {
    return fetch(`${SERVER_URL}/api/v2/client/fhir/configuration`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(clientConfigs)
    }).then(apiHandleResponse);
};

const deleteConfiguration = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/${clientId}`, {
        method: METHOD_DELETE,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getTimezones = () => {
    return fetch(`${SERVER_URL}/api/v2/client/timezones`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const getClientProducts = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/product/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const getClientBranding = () => {
    return fetch(`${SERVER_URL}/api/v1/client/branding`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const createClientBranding = (branding) => {
    return fetch(`${SERVER_URL}/api/v1/client/branding`, {
        method: METHOD_POST,
        headers: headersAuth(),
        body: branding
    }).then(apiHandleResponse);
};

const updateClientBranding = (branding) => {
    return fetch(`${SERVER_URL}/api/v1/client/branding`, {
        method: METHOD_PUT,
        headers: headersAuth(),
        body: branding
    }).then(apiHandleResponse);
};

const getClientBrandingDetails = (facilityId) => {
    return fetch(facilityId ? `${SERVER_URL}/api/v1/client/branding/details/${facilityId}` 
        : `${SERVER_URL}/api/v1/client/branding/details`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const getClientsCustomClaimStatus = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/claimstatus/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const getClientsSummaryDashboardAcccess = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/configuration/summarydashboard/${clientId}`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};
const getClientCreationStages = (clientId) => {
    return fetch(`${SERVER_URL}/api/v2/client/${clientId}/stages`, {
        method: METHOD_GET,
        headers: headersAuthReceiveJson(),
    }).then(apiHandleResponse);
};

const retryClientRegistration = (client) => {
    return fetch(`${SERVER_URL}/api/v3/client/retry/${client.clientId}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const retryClientCreation = (client) => {
    return fetch(`${SERVER_URL}/api/v2/client/retry`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(client)
    }).then(apiHandleResponse);
};

const getClientProductsById = async (id) => {
    return http.get(`/api/v2/client/product/${id}`);
};


export {
    getClients,
    getClientsTiny,
    getClient,
    createClient,
    createClientV3,
    addProducts,
    addBuckets,
    updateClient,
    updateClientNew,
    getParsers,
    bucketAvailability,
    ftpuserAvailability,
    deactivateClient,
    activateClient,
    getConfiguration,
    createConfiguration,
    editConfiguration,
    deleteConfiguration,
    getTimezones,
    getClientProducts,
    getAccountConfiguration,
    getFHIRConfiguration,
    editAccountConfiguration,
    editFHIRConfiguration,
    createAccountConfiguration,
    createFHIRConfiguration,
    testFHIRConnection,
    addClaims,
    getClientBranding,
    createClientBranding,
    updateClientBranding,
    getClientBrandingDetails,
    getClientsCustomClaimStatus,
    getClientsSummaryDashboardAcccess,
    getPlanIdMappingAccess,
    getRcmTeamAccess,
    getEapgAccess,
    getAIAccess,
    getClaimAnalysisChatbotAccess,
    getClientCreationStages,
    retryClientCreation,
    checkIfFHIRConfigExists,
    retryClientRegistration,
    getClientAddress,
    getClientProductsById
};